import {
  SEND_FORGET_PASSWORD_EMAIL,
  SEND_ACCOUNT_ACTIVATION_EMAIL,
  COMPLETE_ACCOUNT_ACTIVATION,
  COMPLETE_PASSWORD_RESET,
  UPDATE_AUTH_USER,
  UPDATE_LOAD_USER,
} from '../../@jumbo/constants/ActionTypes';

const INIT_STATE = {
  authUser: null,
  loadUser: false,
  send_forget_password_email: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case UPDATE_AUTH_USER: {
      return {
        ...state,
        authUser: action.payload,
        loadUser: true,
      };
    }
    case UPDATE_LOAD_USER: {
      return {
        ...state,
        loadUser: action.payload,
      };
    }
    case SEND_FORGET_PASSWORD_EMAIL: {
      return {
        ...state,
        send_forget_password_email: action.payload,
      };
    }
    case SEND_ACCOUNT_ACTIVATION_EMAIL: {
      return {
        ...state,
        send_account_activation_email: action.payload,
      };
    }
    case COMPLETE_ACCOUNT_ACTIVATION: {
      return {
        ...state,
        complete_account_activation: action.payload,
      };
    }
    case COMPLETE_PASSWORD_RESET: {
      return {
        ...state,
        complete_password_reset: action.payload,
      };
    }
    default:
      return state;
  }
};
